/** Roll back optimistic playing on connector proxy_fetch_failed (#10088). Harmless on older connectors that omit failure_step unless self_probe is set. */
import type { ProxyFetchFailedPayload } from '../lib/connector';
import { useMaestroStore } from '../store/maestroStore';
import { diagnosticLog } from './diagnosticLogger';
import { showUserPlayRetryToast } from './playFailureUI';

function shouldRollbackOptimisticPlaying(payload: ProxyFetchFailedPayload): boolean {
  const step = String(payload.failure_step || '').trim();
  if (step === 'stream_service_unreachable') return true;
  return payload.self_probe === 'fail' && step !== 'client_isolation';
}

export function rollbackOptimisticPlayingIfNeeded(payload: ProxyFetchFailedPayload): void {
  if (!shouldRollbackOptimisticPlaying(payload)) return;
  const store = useMaestroStore.getState();
  const ps = String(store.playbackState || '');
  if (ps !== 'playing' && ps !== 'buffering' && ps !== 'loading') return;
  store.setPlaybackState('stopped');
  store.setRendererHasStream(false); // #11005: device has no stream — play() must re-send the current track's URL
  const rendererId = store.activeConnectorRenderer?.id || store.discovery?.activeZone?.id || null;
  const rendererName =
    payload.renderer_name || store.activeConnectorRenderer?.name || store.discovery?.activeZone?.name || 'Your device';
  const track = store.currentTrack as { title?: string; formatId?: number; qobuzFormatId?: number } | null;
  showUserPlayRetryToast(
    track?.title || 'this track', rendererName, payload.guidance || null, track,
    track?.formatId ?? track?.qobuzFormatId ?? null, rendererId,
  );
  diagnosticLog('warn', 'playback', 'proxy_fetch_failed rollback optimistic playing', {
    failure_step: payload.failure_step ?? null,
    self_probe: payload.self_probe ?? null,
    renderer_name: rendererName,
  });
}
